const NOTIFICATION_ICON = '/chat-ui.svg'

function isSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window
}

// Browsers ignore (or quietly block) permission prompts that aren't tied to
// a user gesture, so the prompt waits for the agent's first click anywhere
// in the app. Returns a cleanup for the pending listener.
export function requestNotificationPermissionOnFirstInteraction(): () => void {
  if (!isSupported() || Notification.permission !== 'default') {
    return () => undefined
  }

  const handleInteraction = () => {
    window.removeEventListener('pointerdown', handleInteraction)
    void Notification.requestPermission().catch(() => undefined)
  }

  window.addEventListener('pointerdown', handleInteraction)
  return () => window.removeEventListener('pointerdown', handleInteraction)
}

interface BrowserNotificationOptions {
  title: string
  body: string
  // Notifications sharing a tag replace each other instead of stacking —
  // one per contact is enough.
  tag: string
  onClick: () => void
}

export function showBrowserNotification({
  title,
  body,
  tag,
  onClick,
}: BrowserNotificationOptions): void {
  if (!isSupported() || Notification.permission !== 'granted') return

  try {
    const notification = new Notification(title, {
      body,
      tag,
      icon: NOTIFICATION_ICON,
    })
    notification.onclick = () => {
      window.focus()
      onClick()
      notification.close()
    }
  } catch {
    // Some browsers only allow notifications from a service worker — ignore
  }
}
